export default "__VITE_ASSET__CpC_1u34__"